import { createSelector } from 'reselect';
import { showSmnCaPpageBannerSelector } from 'selectors/testTarget/offers/showSmnCaPpageBanner/showSmnCaPpageBannerSelector';

const showSelector = createSelector(showSmnCaPpageBannerSelector, smnCaPpageBanner => !!smnCaPpageBanner?.show);

export { showSelector };
